//Обратное преобразование буквенного индекса в числовой и обратно
function letterToIndex(letter) {
    let index = 0;
    for (let i = 0; i < letter.length; i++) {
        index = index * 26 + (letter.charCodeAt(i) - 64);
    }
    return index;
}

export function indexToLetter(index) {
    let letter = '';
    while (index >= 0) {
        letter = String.fromCharCode(65 + (index % 26)) + letter;
        index = Math.floor(index / 26) - 1;
    }
    return letter;
}



const addMissingLetters = (obj) => {
    const getMaxKeyIndex = () => {
        let maxIndex = 0;

        for (const key in obj) {
            const keyIndex = letterToIndex(key.toUpperCase());
            maxIndex = Math.max(maxIndex, keyIndex) - 1;
        }

        return maxIndex;
    };

    const maxKeyIndex = getMaxKeyIndex();
    const maxKey = indexToLetter(maxKeyIndex);

    for (let i = 0; i <= maxKeyIndex; i++) {
        const letter = indexToLetter(i).toLocaleLowerCase();

        if (!(letter in obj)) {
            obj[letter] = [];
        }
    }

    const keys = Object.keys(obj);

    keys.sort((a, b) => {
        const indexA = letterToIndex(a);
        const indexB = letterToIndex(b);

        return indexA - indexB;
    });

    const sortedObject = {};

    for (const key of keys) {
        sortedObject[key] = obj[key];
    }

    return sortedObject;
}

const adjustArrays = (arr) => {
    // Находим максимальную длину массива внутри
    const maxLength = Math.max(...arr.map(innerArr => innerArr.length));

    // Добавляем пустые строки или 'XXX' в конец каждого массива
    for (let i = 0; i < arr.length; i++) {
        const currentLength = arr[i].length;
        // Для остальных массивов добавляем пустые строки
        while (arr[i].length < maxLength) {
            arr[i].push('');

        }
    }

    return arr;
}


 //Изменения формата данных для загрузки в таблицу
 export const ImportData = (data, wordMeaning) => {
    console.log(data);

    if (data == null){
        data = []
    }
    if (wordMeaning == null) {
        wordMeaning = []
    }

    let result = [];

    //Праверка на старый массив и его преобразование
    if (Array.isArray(data)) {
        data = { ru: data }
        let transWordMeaning = {}
        for (const key in wordMeaning) {
            const letterKey = indexToLetter(parseInt(key));
            transWordMeaning[letterKey] = wordMeaning[key];
        }
        wordMeaning = transWordMeaning

    }


    for (const [language, rows] of Object.entries(data)) {

        let mergedData = {};


        //Обработка если приходит массив, без слияния ячеек
        if (Array.isArray(rows)) {

            //Нужно для того чтобы перевести Массив в объект (из [хуй, пизда] в {1: хуй, 2: пизда}) так как ассициативных массивы не используют в js и они является объектами, у них не может быть например буквенный индекс
            mergedData = rows.reduce((acc, currentValue, index) => {
                acc[indexToLetter(index).toLowerCase()] = currentValue;
                return acc;
            }, {});
        }
        else {
            //Обработка и слияние ячеек с одинаковыми буквенными индексами

            for (const key in rows) {
                if (rows.hasOwnProperty(key)) {
                    // console.log(rows);
                    // Извлекаем все буквы из ключа (игнорируем цифры)
                    const letters = key.match(/[a-zA-Z]/g).join('').toLowerCase();

                    if (mergedData[letters]) {
                        // Если ключ уже существует в mergedData, добавляем текущий массив к существующему
                        rows[key][0][0] = "," + rows[key][0][0];
                        mergedData[letters] = mergedData[letters].concat(rows[key]);
                    } else {
                        // Если ключ не существует в mergedData, создаем новый ключ и присваиваем ему текущий массив
                        // console.log(key);
                        // console.log(rows[key]);
                        mergedData[letters] = rows[key].slice();
                    }
                }
            }
        }


        mergedData = addMissingLetters(mergedData)

        let languageRow = [language];
        for (let i = 0; i < Object.entries(mergedData).length; i++) {
            const row = Object.entries(mergedData)[i][1];
            const index = Object.entries(mergedData)[i][0];
            let newRow = "";
            for (let j = 0; j < row.length; j++) {
                const cell = row[j];
                if (j === 0 || cell[0].includes(',')) {
                    if (cell[1] === 1) {
                        newRow += cell[0];
                    }
                    else {
                        newRow += cell[0].includes(',') ? cell[0].substring(0, 1) + '-' + cell[0].substring(1) : `-${cell[0]}`;
                    }

                } else {
                    if (cell[1] === 1) {
                        newRow += "+" + cell[0];
                    } else if (cell[1] === -1) {
                        newRow += "-" + cell[0];
                    } else {
                        newRow += cell[0];
                    }
                }
            }
            languageRow.push(newRow);
        }
        result.push(languageRow);
    }

    result = adjustArrays(result)

    //Массив преобразуется и добавляется дополнительная строка в таблицу
    let WordMeaningTemplate = []
    for (let r = 0; r, r < result[0].length - 1; r++) {
        if (wordMeaning[indexToLetter(r)]) {
            WordMeaningTemplate.push(Object.values(wordMeaning[indexToLetter(r)]).filter(val => val !== "").join("|"))
        }
        else { WordMeaningTemplate.push('XXX') }
    }

    // wordMeaning = wordMeaning.map(obj => {
    //     let combined = Object.values(obj).filter(val => val !== "").join("|");
    //     return combined === "" ? "" : `${combined}`;
    // });
    result.push(['Meaning', ...WordMeaningTemplate]);
    // this.Table.loadData(result);
    // this.Table.updateSettings({
    //     width: result[0].length * 210
    //  });
    return result
};


//Загрузка данных в таблицу
// ImportData(tableData, wordMeaning);



export const ExportData = (tableData) => {
    let inputArray = tableData.map((el) => el.map((obj) => obj === null ? '' : obj));
    const data = {};
    let wordMeans = {}

    for (let i = 0; i < inputArray.length - 1; i++) {
        const [language, ...rows] = inputArray[i];
        const languageData = {};
        let alphRepeat = 0
        for (let j = 0; j < rows.length; j++) {

            const row = rows[j].split(',');
            let columnIndex = j;
            let currentLetter = '';

            // Переводим индекс в буквенный формат (A, B, ..., Z, AA, AB, ...)
            while (columnIndex >= 0) {
                currentLetter = String.fromCharCode(65 + (columnIndex % 26)) + currentLetter;
                columnIndex = Math.floor(columnIndex / 26) - 1;
            }

            let currentNumber = 1;

            for (let k = 0; k < row.length; k++) {
                const cell = row[k].trim();
                const key = currentLetter + '-' + currentNumber;
                if (cell !== '') {

                    const wordPairs = cell.split(/([\+\-])/).filter(Boolean);
                    let wordDataArray = [];
                    let value = 1;
                    for (let j = 0; j < wordPairs.length; j++) { //wordPairs представляют собой массив поделенной строки которые разделились по запятым, которая може включать + - и слово, например ["-","уже","+","оформил*", "+","[штраф]*"], тут и проверяется какой знак стоит перед словом и соответственно ставят в массив 1 или -1 [['уже', -1], ["оформил*", 1], ["[штраф]*", 1]]
                        const w = wordPairs[j].trim();
                        if (w === '+' || w === '-') {
                            value = w === '-' ? -1 : 1;
                        } else {
                            wordDataArray.push([w, value]);
                        }
                    }

                    if (!languageData[key]) {
                        languageData[key] = [];
                    }
                    languageData[key].push(...wordDataArray);
                    currentNumber++;
                }
                // if (cell == '') {
                //     if (!languageData[key]) {
                //         languageData[key] = [];
                //     }

                // }

            }
        }
        data[language] = languageData;
    }



    //Преобразование массива со значениями слов
    inputArray[inputArray.length - 1].slice(1).forEach((el, index) => {

        let means = {}
        let elArr = el.split('|')
        if (el != 'XXX' && el != 'ХХХ') {
            if (elArr[0]) {
                means.assertion = elArr[0];
            }
            if (elArr[1]) {
                means.negation = elArr[1];
            }
            if (elArr[2]) {
                means.question = elArr[2];
            }
            if (elArr[3]) {
                means.conditional = elArr[3];
            }
            if (el !== '') {
                wordMeans[indexToLetter(index)] = means
            }
            if (el == '') {
                wordMeans[indexToLetter(index)] = { 'assertion': '' }
            }
            means = {}
        }

    });

    return { data, wordMeans };
}

